import { Database } from "lucide-react";

/**
 * SourceBadge — small pill that labels where a KPI number comes from.
 *
 * Usage: <SourceBadge label="Monthly Goals sheet" tone="cobalt" hint="Curated by Joey/Katie · synced 6h" />
 *
 * Tones map to the brand palette. Hover reveals the hint text so we don't
 * clutter the tile with long descriptions.
 */
const TONE_CLS = {
  cobalt:    "text-cobalt border-cobalt/40",
  navy:      "text-navy border-navy/40",
  evergreen: "text-evergreen border-evergreen/40",
  yellow:    "text-midnight bg-yellow border-yellow",
};

export default function SourceBadge({ label, tone = "cobalt", hint, testid }) {
  const cls = TONE_CLS[tone] || TONE_CLS.cobalt;
  return (
    <span title={hint || undefined}
          data-testid={testid || "source-badge"}
          className={`inline-flex items-center gap-1 border px-1.5 py-0.5 text-[9px] uppercase tracking-widest font-bold ${cls} whitespace-nowrap`}>
      <Database className="w-2.5 h-2.5 opacity-70" />
      {label}
    </span>
  );
}
